export default __webpack_public_path__ + "static/media/logo.788c3a71.svg";